"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var TagIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 28 29", fill: "currentColor", width: size || '28', height: size || '29' }, props),
        React.createElement("path", { fill: "currentColor", d: "M12.29 28.077a3.405 3.405 0 0 1-2.416-1.002l-8.876-8.9a3.438 3.438 0 0 1 0-4.844L13.293 1.003A3.391 3.391 0 0 1 15.708 0h8.876A3.424 3.424 0 0 1 28 3.425v8.902c0 .913-.355 1.774-1 2.42L14.707 27.075a3.406 3.406 0 0 1-2.417 1.002zm7.704-21.325c.34 0 .659.132.9.373a1.28 1.28 0 0 1 0 1.804c-.482.481-1.32.481-1.8 0a1.28 1.28 0 0 1 0-1.804c.241-.24.56-.373.9-.373zm0 4.702c.91 0 1.769-.357 2.415-1.003a3.438 3.438 0 0 0 0-4.844c-1.294-1.295-3.543-1.293-4.83 0a3.438 3.438 0 0 0 0 4.844 3.39 3.39 0 0 0 2.415 1.003z", fillRule: "evenodd" })));
};
TagIcon.displayName = 'TagIcon';
exports.default = TagIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TagIcon.js.map